import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  featureHeader: {
    id: 'upsell-table.table-header.features',
    defaultMessage: 'Features',
    description: 'Screenreader text for feature column header',
  },
  auditHeader: {
    id: 'upsell-table.table-header.audit',
    defaultMessage: 'Audit Track',
    description: 'Text for the audit track column header',
  },
  verifiedHeader: {
    id: 'upsell-table.table-header.verified',
    defaultMessage: 'Verified Track',
    description: 'Text for the verified track column header',
  },
  certificateLinkText: {
    id: 'upsell.features.certificate.hyperlink',
    defaultMessage: 'verified certificate',
    description: 'Text for verfied certificate explanation link',
  },
  certificate: {
    id: 'upsell.features.certificate',
    defaultMessage: 'Shareable {certificateLink}',
    description: 'Text for certificate feature cell',
  },
  grades: {
    id: 'upsell.features.grades',
    defaultMessage: 'Graded assessments and assignments',
    description: 'Text for grades feature cell',
  },
  access: {
    id: 'upsell.features.access',
    defaultMessage: 'Unlimited access to all course materials',
    description: 'Text for access feature cell',
  },
  learningAssistant: {
    id: 'upsell.features.learning-assistant',
    defaultMessage: 'AI learning assistant and translations',
    description: 'Text for learning assistant feature cell',
  },
  notIncludedAltMessage: {
    id: 'upsell-table.table-row.audit.not-included',
    defaultMessage: 'This feature is not included in the audit track',
    description: 'Alt message for x icon in the audit track column',
  },
  includedAltMessage: {
    id: 'upsell-table.table-row.audit.not-included',
    defaultMessage: 'This feature is included in the verified track',
    description: 'Alt message for check icon in the verified track column',
  },
  tableSectionHeader: {
    id: 'upsell-table.section.header',
    defaultMessage: 'Compare benefits of upgrading',
    description: 'Header for section dispaly audit and verified comparison',
  },
});

export default messages;
